<template>
<div>
  <h2>Touren Übersicht</h2>

  <router-link to="/tourplanner">
    <span class="upload-caption ui button">Tour hinzufügen</span>
  </router-link>
  <div style="text-align: left; margin-top: 50px;">
    <div class="ui celled list">

      <div v-for="tour in tours" class="item" v-bind:class="{'active': setActive(tour.startdate)}">

        <div class="right floated content">
              <div v-bind:class="['ui', {'disabled': !setActive(tour.startdate)}, 'button']" @click="editTour(tour.uid)">Edit</div>
            </div>
        <img class="ui small image" style="max-width: 100px;" :src="config.filedelivery +'/images/touren/' + tour.data.images[0]">

        <div class="content">
          <div class="header">{{tour.data.titel | uppercase}}</div><i v-bind:class="[tour.data.country, flag]"></i>
          Vom: {{tour.startdate}} Bis: {{tour.enddate}}<br>
          {{tour.data.place | uppercase}}
        </div>
      </div>

    </div>
  </div>
</div>
</template>

<script>
import Config from '../Config';
import User from '../enteties/User';

const axios = require('axios');


export default {
  name: 'Touren',
  props: {},
  data: function() {
    return {
      config: Config,
      flag: 'flag',
      user: User,
      date: 0,
      hasImage: false,
      tours: []
    }
  },
  created: function() {
    if (!this.user.logedin) {
      this.$router.push({
        path: 'login'
      })
    }
    axios.get(this.config.protocol + "://" + this.config.apihost + "/private/tour")
      .then((response) => {
        this.tours = response.data.data;
        this.sortbyDate();

        console.log(this.tours);

      })
      .catch(function(error) {
        console.log(error);
      })

  },
  components: {
  },
  methods: {
    openDocumentation: function() {
      this.$router.push({
        path: 'documentation'
      })
    },
    editTour: function(uid) {
      this.$router.push({
        path: 'tourplanner',
        query: { uid: uid }
      })
    },
    setImage: function (file) {
     //this.hasImage = true
     this.images.push(file)
   },
   sortbyDate: function() {
      this.tours.sort((a, b) => (a.startdate > b.startdate) ? 1 : -1).reverse()
    },
    setActive: function(date) {
      let d = new Date(date);
      let c = new Date();

      return d.getTime() > c.getTime();
    }
  }
}
</script>

<style>

#fileInput {
  display: none;
}

.quill-editor {
    border: 1px solid #ccc;
    width: 100%;
}

</style>
